import { LANG_EN } from '../../core/lang/constants';
import { COMMAND_SHOW_CREATE_CAMPAIGN_DIALOG } from '../../campaign/constants';


/* eslint-disable no-restricted-globals */
export const getHost = () => {
  const { protocol, hostname } = location;

  return `${protocol}//${hostname}/`;
};
/* eslint-enable no-restricted-globals */

const getUrl = (lang, url) => `${lang ? `/${lang}` : ''}/webmaster-panel/${url}`;

export const getIndexUrl = lang => getUrl(lang, '');
export const getHowToStartUrl = lang => getUrl(lang, 'how-to-start');
export const getEditProfileUrl = lang => getUrl(lang, 'profile');
export const getBalanceSummaryUrl = lang => getUrl(lang, 'balance-summary');
export const getDebtUrl = lang => getUrl(lang, 'losses-compensations');
export const getRivcashForumUrl = lang => (
  `http://forum.rivcash.com${lang === LANG_EN ? '#english-forum' : ''}`
);
export const getRevenueUrl = lang => getUrl(lang, 'revenue');
export const getCampaignsStatsUrl = lang => getUrl(lang, 'stats');
export const getAffiliatedUsersUrl = lang => getUrl(lang, 'users');
export const getAffiliatedWebmastersUrl = lang => getUrl(lang, 'webmasters');
export const getBalanceAdjustmentsUrl = lang => getUrl(lang, 'balance-adjustments');
export const getPayoutRequestsUrl = lang => getUrl(lang, 'requests');
export const getPayoutFeesUrl = lang => getUrl(lang, 'fees');
export const getPayoutSettingsUrl = lang => getUrl(lang, 'payout-settings');
export const getCampaignsUrl = (lang, isShowCreateCampaignDialog = false) => (
  `${getUrl(lang, 'campaigns')}${isShowCreateCampaignDialog ? `?${COMMAND_SHOW_CREATE_CAMPAIGN_DIALOG}=1` : ''}`
);
export const getAffiliateToolsUrl = lang => getUrl(lang, 'affiliate-tools');
export const getPostbackSettingsUrl = lang => getUrl(lang, 'postback-settings');
export const getSitesUrl = lang => getUrl(lang, 'sites');

// region WEBMASTER SITE URLS

const getWebmasterSiteBaseUrl = (lang, siteId) => `${getSitesUrl(lang)}/${siteId}`;

// Settings

export const getWebmasterSiteSettingsUrl = (lang, siteId) => (
  `${getWebmasterSiteBaseUrl(lang, siteId)}/settings`
);
export const getWebmasterSiteTemplateConfigurationUrl = (lang, siteId) => (
  `${getWebmasterSiteBaseUrl(lang, siteId)}/settings/template-configuration`
);
export const getWebmasterSiteGoogleAnalyticsUrl = (lang, siteId) => (
  `${getWebmasterSiteBaseUrl(lang, siteId)}/settings/google-analytics`
);
export const getWebmasterSiteGoogleToolUrl = (lang, siteId) => (
  `${getWebmasterSiteBaseUrl(lang, siteId)}/settings/google-webmaster-tools`
);
export const getWebmasterSiteAliasesUrl = (lang, siteId) => (
  `${getWebmasterSiteBaseUrl(lang, siteId)}/settings/aliases`
);
export const getWebmasterSiteFaviconUrl = (lang, siteId) => (
  `${getWebmasterSiteBaseUrl(lang, siteId)}/settings/favicon`
);

// SEO

export const getWebmasterSiteSeoUrl = (lang, siteId) => (
  `${getWebmasterSiteBaseUrl(lang, siteId)}/seo`
);
export const getWebmasterSiteCustomTagsUrl = (lang, siteId) => (
  `${getWebmasterSiteBaseUrl(lang, siteId)}/seo/custom-tags`
);

// Content

export const getWebmasterSiteContentUrl = (lang, siteId) => (
  `${getWebmasterSiteBaseUrl(lang, siteId)}/content`
);
export const getWebmasterSiteArticlesUrl = (lang, siteId) => (
  `${getWebmasterSiteBaseUrl(lang, siteId)}/content/articles`
);
export const getWebmasterSitePagesUrl = (lang, siteId) => (
  `${getWebmasterSiteBaseUrl(lang, siteId)}/content/pages`
);
export const getWebmasterSiteFooterLinksUrl = (lang, siteId) => (
  `${getWebmasterSiteBaseUrl(lang, siteId)}/content/footer-links`
);
export const getWebmasterSiteTextsUrl = (lang, siteId) => (
  `${getWebmasterSiteBaseUrl(lang, siteId)}/content/texts`
);

// Banners

export const getWebmasterSiteBannersUrl = (lang, siteId) => (
  `${getWebmasterSiteBaseUrl(lang, siteId)}/banners`
);
export const getWebmasterSiteLinksUrl = (lang, siteId) => (
  `${getWebmasterSiteBaseUrl(lang, siteId)}/banners/links`
);

// endregion WEBMASTER SITE URLS

export const getSiteBuilderUrl = lang => `${getSitesUrl(lang)}/create`;
export const getSiteAliasesUrl = lang => getUrl(lang, 'site-aliases');
export const getBannersUrl = lang => getUrl(lang, 'banners');
export const getUnsuspendPageUrl = lang => getUrl(lang, 'unsuspend-me');
